import { Module } from 'vuex';

import { RootState, ListStatus } from '@/store/types';
import Pagination from '@/store/models/pagination';
import { SendGridEmailState } from './types';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const getInitialState = (): SendGridEmailState => ({
  status: ListStatus.Loading,
  list: [],
  listPagination: new Pagination(),
  summary: null,
});

export const state: SendGridEmailState = getInitialState();

const sendgridEmails: Module<SendGridEmailState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default sendgridEmails;
